import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useQuoteStore } from 'src/hooks/quote';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const ClearQuotePopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ ClearQuotePopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ openQuoteList}, { }, { clear_all_quote, set_is_success_action }] = useQuoteStore();

    useEffect(() => {
        if (ClearQuotePopup) {
            SetStatus(true)
            let quoteList = openQuoteList?.records;
            let prodDetails = [];
            Object.entries(quoteList).map((data,i)=>{
                console.log(data[1])
                let makeObj = {...data[1]?.product};
                makeObj.quoteID = data[1]?.quoteLineItemId;
                prodDetails.push(makeObj)
            })
        }
    }, [ClearQuotePopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const clearedAllQuote = async () => {

        const res = await clear_all_quote();
        if (res.isSuccessFull)
            set_is_success_action(true)
        onHide()
        removeQuoteEvent();
    };

    //By Ramya Kannan [Quote Removal - Adobe script ]
    function removeQuoteEvent(){
        localStorage.setItem("adobeEventType","quoteRemovalEvent");
        let quoteList = openQuoteList?.records;
            let prodDetails = [];
            Object.entries(quoteList).map((data,i)=>{
                let makeObj = {...data[1]?.product};
                makeObj.quoteID = data[1]?.quoteLineItemId;
                prodDetails.push(makeObj)
            })
        let cartDetails = {
            "cartType":"Quote",
            "additionSource" : ClearQuotePopup?.data?.addFrom,

        }
        if(prodDetails.length){
            HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails});
        }
    }

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-730">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×</button>
                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">Clear This Quote</h3>
                        </div>
                        <div className="modal-body">
                            <p className="text-center">Once cleared, You will <b>LOSE ALL ITEMS</b> in your <b>“MY OPEN QUOTE LIST”</b></p>
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary"
                                onClick={() => {
                                    onHide()
                                }}>back to quote</button>
                            <button type="button" className="bs5 btn btn-primary"
                                onClick={() => {
                                    clearedAllQuote()
                                }}>Clear quote</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ClearQuotePopup;